import { useQuery } from '@tanstack/react-query'
import { useWorkspaceContext } from '~/contexts/WorkspaceContext'
import { getConnectionMetadataList } from '~/services/organizationService'
import { QueryKeys } from '~/services/queryClient'

export function useConnectionMetadata() {
  const { currentWorkspace } = useWorkspaceContext()

  return useQuery({
    queryKey: [QueryKeys.ConnectionMetadata, currentWorkspace?.uuid],
    queryFn: () => {
      if (!currentWorkspace?.uuid) throw new Error('Workspace not found')
      return getConnectionMetadataList(currentWorkspace.uuid)
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    enabled: !!currentWorkspace?.uuid
  })
}
